import { useSyncExternalStore } from 'react';

import { getDevFlag, subscribeDevFlag } from './devConsole';

export const useDevFlag = (key: string) =>
  useSyncExternalStore(
    subscribeDevFlag,
    () => getDevFlag(key),
    () => false,
  );
